import { render, staticRenderFns } from "./Certificates.vue?vue&type=template&id=216c4af5"
import script from "./Certificates.vue?vue&type=script&lang=js"
export * from "./Certificates.vue?vue&type=script&lang=js"
import style0 from "./Certificates.vue?vue&type=style&index=0&id=216c4af5&prod&lang=css"
import style1 from "./Certificates.vue?vue&type=style&index=1&id=216c4af5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports